// extracted by mini-css-extract-plugin
module.exports = {"banner":"curiousBanner_banner__2DF8m","header":"curiousBanner_header__kt6sM","image":"curiousBanner_image__QMReO"};